module.exports = __webpack_public_path__ + "img/lg_ring_r_e_0_1.74ec800a.png";